import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './RegistrationCodePage.css';

export function RegistrationCodePage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const register = (event: React.FormEvent) => {
    event.preventDefault();
    localStorage.setItem('activationEmail', email);
    localStorage.setItem('activationCode', password);
    navigate('/set-password');
  };

  return (
    <main
      className="registration-code-page"
      style={{ '--registration-background-image': "url('/images/StartImage.jpg')" } as React.CSSProperties}
    >
      <section className="registration-code-page__card">
        <button
          type="button"
          onClick={() => navigate('/login')}
          className="registration-code-page__back"
          aria-label="Zurück zur Anmeldung"
        >
          <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" aria-hidden="true">
            <path
              d="M19 12H5m6-6-6 6 6 6"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Zurück
        </button>

        <div className="registration-code-page__header">
          <div className="registration-code-page__badge">
            <svg viewBox="0 0 24 24" className="registration-code-page__badge-icon" fill="none" aria-hidden="true">
              <circle cx="9" cy="6" r="4" stroke="currentColor" strokeWidth="1.6" />
              <path
                d="M14.8 21H3v-6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="17.5" cy="18.5" r="5.2" fill="currentColor" />
              <path d="M17.5 15.8v5.4M14.8 18.5h5.4" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" />
            </svg>
          </div>

          <h1 className="registration-code-page__title">Registrierung</h1>
        </div>

        <p className="registration-code-page__description">
          Bitte geben Sie Ihre E-Mail Adresse sowie das dazugehörige Passwort ein, welches Sie mit separater Post erhalten
          haben.
        </p>

        <form className="registration-code-page__form" onSubmit={register}>
          <label htmlFor="registration-email" className="registration-code-page__label">
            E-Mail Adresse (aus separater Post)
          </label>
          <div className="registration-code-page__field">
            <svg viewBox="0 0 24 24" className="registration-code-page__field-icon" fill="none" aria-hidden="true">
              <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.6" />
              <path
                d="m4 7 8 6 8-6"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <input
              id="registration-email"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="name@beispiel.de"
              className="registration-code-page__input"
            />
          </div>

          <label
            htmlFor="registration-password"
            className="registration-code-page__label registration-code-page__password-label"
          >
            Passwort (aus separater Post)
          </label>
          <div className="registration-code-page__field">
            <svg viewBox="0 0 24 24" className="registration-code-page__field-icon" fill="none" aria-hidden="true">
              <rect x="5" y="10" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.6" />
              <path d="M8 10V7a4 4 0 0 1 8 0v3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
            </svg>
            <input
              id="registration-password"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="••••••••"
              className="registration-code-page__input registration-code-page__input--password"
            />
            <button
              type="button"
              onClick={() => setShowPassword((currentValue) => !currentValue)}
              className="registration-code-page__toggle"
              aria-label={showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'}
            >
              <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" aria-hidden="true">
                <path
                  d="M2.5 12s3.5-5 9.5-5 9.5 5 9.5 5-3.5 5-9.5 5-9.5-5-9.5-5Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                />
                <circle cx="12" cy="12" r="2.25" stroke="currentColor" strokeWidth="1.5" />
              </svg>
            </button>
          </div>

          <button type="submit" className="registration-code-page__submit">
            Jetzt anmelden
          </button>
        </form>

        <aside className="registration-code-page__help">
          <p>Brief mit Zugangsdaten verloren? Wir helfen Ihnen gerne weiter. Rufen Sie uns an:</p>
          <div className="registration-code-page__contact">
            <svg viewBox="0 0 24 24" className="registration-code-page__phone-icon" fill="none" aria-hidden="true">
              <path
                d="M7.2 3.5 10 8 8.3 9.7c1.2 2.5 3.4 4.6 5.9 5.8l1.7-1.7 4.6 2.8-.6 3c-.2.9-1 1.5-1.9 1.4C9.7 20.1 3.8 14.3 3 6c-.1-.9.5-1.7 1.4-1.9l2.8-.6Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div className="registration-code-page__contact-copy">
              <a href="tel:+41526254625" className="registration-code-page__phone">
                052 625 46 25
              </a>
              <p className="registration-code-page__hours">Mo. – Fr., 08:00 – 17:00 Uhr</p>
            </div>
          </div>
        </aside>
      </section>
    </main>
  );
}
